import {Pipe, PipeTransform} from '@angular/core';

@Pipe({ name: 'ShortNamePipe'})

export class ShortNamePipe implements PipeTransform  {

    constructor(){}

    transform(value) {
        return value.split(' ').map(n => n[0]).join('');
    }
}
